export const removeTrailingSlash = (str) => str.endsWith("/") ? str.substring(0, str.length - 1) : str;
export function validApplicationNumber(appNo) {
    return appNo && Number(appNo.replace("-", "")) > 0;
}
//# sourceMappingURL=utils.js.map